import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ContentChild,
    EventEmitter,
    HostBinding,
    Input,
    Output,
} from "@angular/core";

import { SpsSummaryListExpansionComponent } from "../summary-list-expansion/sps-summary-list-expansion.component";

@Component({
    selector: "sps-summary-list-row",
    templateUrl: "./sps-summary-list-row.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SpsSummaryListRowComponent {
    static readonly displayName = "sps-summary-list-row";
    static readonly props = {
        selected: "boolean",
        expanded: { event: true, type: "void" },
        collapsed: { event: true, type: "void" },
    };

    @Input()
    @HostBinding("class.sps-summary-list-row--selected")
    selected = false;

    @Output() expanded: EventEmitter<void> = new EventEmitter();
    @Output() collapsed: EventEmitter<void> = new EventEmitter();

    @HostBinding("class.sps-content-row") readonly spsContentRowClass = true;
    @HostBinding("class.sps-summary-list-row") readonly spsSummaryListRowClass = true;

    @ContentChild(SpsSummaryListExpansionComponent, { static: false }) expansion: SpsSummaryListExpansionComponent;

    @HostBinding("class.sps-summary-list-row--expandable")
    get hasExpansion() {
        return !!this.expansion;
    }

    private _isExpanded = false;
    @HostBinding("class.sps-content-row--expanded")
    get isExpanded() {
        return this._isExpanded;
    }
    set isExpanded(value: boolean) {
        if (this.hasExpansion && value !== this._isExpanded) {
            this._isExpanded = value;
            if (value) {
                this.expanded.emit();
            } else {
                this.collapsed.emit();
            }
            this.changeDetectorRef.markForCheck();
        }
    }

    constructor(private changeDetectorRef: ChangeDetectorRef) { }

    _onMainRowClick(event: MouseEvent) {
        if (!event.defaultPrevented) {
            this.toggle();
        }
    }

    _onKeyDown(event: KeyboardEvent) {
        if ((event.key === "Enter" || event.key === " " || event.key === "Spacebar") && !event.defaultPrevented) {
            event.preventDefault();
            this.toggle();
        }
    }

    expand() {
        this.isExpanded = true;
    }

    toggle() {
        this.isExpanded = !this.isExpanded;
    }

    collapse() {
        this.isExpanded = false;
    }
}
